module.exports = __webpack_public_path__ + "img/Gallery.0b9b6e2f.png";